// extracted by mini-css-extract-plugin
export default {"title":"MenuItem_title__szfe2","contents":"MenuItem_contents__M8Z13","contentItem":"MenuItem_contentItem__NDo9H","item":"MenuItem_item__tmW6A"};